/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaPipelineStageFromJSON, MediaPipelineStageToJSON, } from './MediaPipelineStage';
import { MediaProcessingStatusFromJSON, MediaProcessingStatusToJSON, } from './MediaProcessingStatus';
import { VirusScanStatusFromJSON, VirusScanStatusToJSON, } from './VirusScanStatus';
/**
 * Check if a given object implements the StaffFileProcessingResponse interface.
 */
export function instanceOfStaffFileProcessingResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffFileProcessingResponseFromJSON(json) {
    return StaffFileProcessingResponseFromJSONTyped(json, false);
}
export function StaffFileProcessingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'isVideo': !exists(json, 'isVideo') ? undefined : json['isVideo'],
        'status': !exists(json, 'status') ? undefined : MediaProcessingStatusFromJSON(json['status']),
        'virusScanStatus': !exists(json, 'virusScanStatus') ? undefined : VirusScanStatusFromJSON(json['virusScanStatus']),
        'isQuarantined': !exists(json, 'isQuarantined') ? undefined : json['isQuarantined'],
        'stage': !exists(json, 'stage') ? undefined : MediaPipelineStageFromJSON(json['stage']),
        'stageUpdatedAt': !exists(json, 'stageUpdatedAt') ? undefined : (json['stageUpdatedAt'] === null ? null : new Date(json['stageUpdatedAt'])),
        'percent': !exists(json, 'percent') ? undefined : json['percent'],
    };
}
export function StaffFileProcessingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileId': value.fileId,
        'fileName': value.fileName,
        'isVideo': value.isVideo,
        'status': MediaProcessingStatusToJSON(value.status),
        'virusScanStatus': VirusScanStatusToJSON(value.virusScanStatus),
        'isQuarantined': value.isQuarantined,
        'stage': MediaPipelineStageToJSON(value.stage),
        'stageUpdatedAt': value.stageUpdatedAt === undefined ? undefined : (value.stageUpdatedAt === null ? null : value.stageUpdatedAt.toISOString()),
        'percent': value.percent,
    };
}
